export default "__VITE_ASSET__e79c99a4__"